
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6 12.001a.712.712 0 01.045-.248l.008-.021a.7.7 0 01.159-.237l4.333-4.284a.726.726 0 011.021 0 .707.707 0 010 1.01l-3.1 3.067h9.812a.715.715 0 110 1.429H8.466l3.1 3.067a.707.707 0 010 1.01.726.726 0 01-1.021 0l-4.332-4.293a.726.726 0 01-.158-.234l-.01-.025A.684.684 0 016 12.001z","fill":"currentColor"}})])
          )
        }
      }
    